<template>
  <div id="storeInformation">
    <div style="position: relative; top: 0; left: 0;">
      <div
        :style="{
          height: `${phoneSearchHeight}px`
        }"
      />
      <!-- <Banner ref="banner" :banner-cat-id="11" class="banner" />
      <MyCould /> -->
    </div>

    <div style="padding: 5vh 5vw;">
      <!-- <el-image
        :src="'https://www.wellsoon.cn/uploads/files/70346352-f37b-4451-8025-bed8e7bc8b1d.png?type=cms'"
        alt="公司简介中药团队"
      /> -->
      <Banner ref="banner" :banner-cat-id="14" class="banner" />
    </div>
  </div>
</template>

<script>
import API from '@/api/service'
// import sideBar from '@/components/sideBar'

export default {
  // eslint-disable-next-line vue/name-property-casing
  name: 'storeInformation',
  // components: {
  //   sideBar
  // },
  data() {
    return {
      innerWidthType: '',
      articleData: [],
      articleInfoDetail: {},
      isShowCould: false,
      parent_id: 0,
      searchData: {
        id: '',
        limit: 10,
        page: 1
      },
      showBanner: false,
      title: '',
      titleFont: {
        33: '门店信息'
      },
      topHeight: 0,
      total: 0,
      jpzyImgHeight: 0,
      phoneSearchHeight: 0
    }
  },
  watch: {
    $route(newVal) {
      const bannerTop = document.querySelector('.banner').clientHeight
      document.body.scrollTop = bannerTop
      document.documentElement.scrollTop = bannerTop
      this.searchData = {
        id: '',
        limit: 10,
        page: 1
      }
      this.getArticleContent()
    }
  },
  created() {
    this.showBanner = true
    this.parent_id = Number(this.$route.params.parent_id)
    this.getArticleContent()
    this.getInnerWidthType()
    window.addEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.addEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
  },
  destroyed() {
    window.removeEventListener('scroll', () => {
      this.setSideBarFix()
    })
    window.removeEventListener('resize', () => {
      this.getInnerWidthType()
      this.setSideBarFix()
    })
  },
  methods: {
    getInnerWidthType() {
      if (window.innerWidth >= 1920) {
        this.innerWidthType = 'xl'
      } else if (window.innerWidth >= 1200) {
        this.innerWidthType = 'lg'
      } else if (window.innerWidth >= 992) {
        this.innerWidthType = 'md'
      } else if (window.innerWidth > 768) {
        this.innerWidthType = 'sm'
      } else {
        this.innerWidthType = 'xs'
      }
    },
    setSideBarFix() {
      if (this.$refs.banner) {
        const bannerHeight = this.$refs.banner.$el.offsetHeight
        const bannerTop = this.$refs.banner.$el.offsetTop
        const scTop =
          document.documentElement.scrollTop || document.body.scrollTop
        const top = scTop + bannerTop
        const ofHeight =
          document.documentElement.offsetHeight || document.body.offsetHeight
        const clHeight =
          document.documentElement.clientHeight || document.body.clientHeight
        const footerBottom = document.querySelector('#footer').clientHeight
        const sideHeight =
          document.querySelector('.side-bar-container').clientHeight -
          document.querySelector('.side-bar').clientHeight
        if (scTop > 200 && scTop < 500 && !this.isShowCould) {
          this.isShowCould = true
        }
        if (top >= bannerHeight + bannerTop) {
          this.topHeight = top - (bannerHeight + bannerTop)
        } else {
          this.topHeight = 0
        }

        if (
          sideHeight - this.topHeight < 0 &&
          footerBottom > ofHeight - scTop - clHeight
        ) {
          this.topHeight = sideHeight
        }
      }
      if (Number(this.$route.params.id) === 33) {
        const oImg = document.querySelector('.wscnph')
        if (oImg) {
          this.jpzyImgHeight = oImg.clientHeight / 2 + 20
        }
      }
    },
    getArticleContent() {
      this.searchData.id = this.$route.params.id
      this.title = this.titleFont[Number(this.searchData.id)]
      if (this.$route.query.id) {
        const parms = { id: this.$route.query.id }
        API.getArticleDate(parms).then(res => {
          this.articleInfoDetail = res.data
          this.$nextTick(() => {
            setTimeout(() => {
              const oImg = document.querySelector('.wscnph')
              if (oImg) {
                this.jpzyImgHeight = oImg.clientHeight / 2 + 20
              }
            }, 100)
          })
        })
      } else {
        this.searchData.limit = Number(this.$route.params.id) === 33 ? 9 : 10
        API.getArticleList({ ...this.searchData }).then(res => {
          this.articleData = res.data
          this.total = res.count
        })
      }
    },
    handleCurrentChange(val) {
      this.searchData.page = val
      this.getArticleContent()
    },
    setHeight() {
      this.$parent.getHeightList()
    },
    goDetail(data) {
      this.$router.push({
        name: this.$route.name,
        params: {
          parent_id: this.$route.params.parent_id,
          id: this.$route.params.id
        },
        query: { id: data.id }
      })
    },
    setPhoneSearchHeight(data) {
      this.phoneSearchHeight = data
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/storeInformation/xl.scss";
@media screen and (max-width: 1920px) {
  @import "@/assets/css/storeInformation/lg.scss";
}
@media screen and (max-width: 1200px) {
  @import "@/assets/css/storeInformation/md.scss";
}
@media screen and (max-width: 992px) {
  @import "@/assets/css/storeInformation/sm.scss";
}
@media screen and (max-width: 768px) {
  @import "@/assets/css/storeInformation/xs.scss";
}
</style>



// WEBPACK FOOTER //
// src/view/storeInformation.vue